"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var normalization_1 = require("rest-resource/dist/helpers/normalization");
var date_1 = require("../date");
tslib_1.__exportStar(require("rest-resource/dist/helpers/normalization"), exports);
var DateNormalizer = /** @class */ (function (_super) {
    tslib_1.__extends(DateNormalizer, _super);
    function DateNormalizer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateNormalizer.prototype.normalize = function (value) {
        var valString = _super.prototype.normalize.call(this, value);
        var val = valString + " 00:00:00:00";
        return date_1.normalizeUserDateInput(val);
    };
    return DateNormalizer;
}(normalization_1.StringNormalizer));
exports.DateNormalizer = DateNormalizer;
//# sourceMappingURL=normalization.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/util/resources/normalization.js
// module id = qDOe
// module chunks = 0